export { registerComponent as registerRootComponent } from '../../components/builtin/Root/register'
export { default as Root } from '../../components/builtin/Root/Root'
